<div class="modal-body px-3 py-5">
  <div class="justify-content-between mb-2 text-center">
      <img src="../../assets/default-location.png" class="empty-state-img mb-5"/>

    <div class="text-center justify-content-between align-items-center">
      <span class="font-weight-500 f-16">
          Set Location Preference
      </span>
      <p class="f-14 mb-4 line-height-1 mt-1">This region is used by default when no location is selected in your search.<br> You can update it anytime or search globally by adding locations.</p>
    </div>
    <div class="text-center justify-content-between align-items-center mx-auto" style="width: 65%;">
      <p class="f-14 font-weight-400 mb-1 text-left">Region Preference</p>
        <select data-testid="auto-app-default-location-modal-select-1" name="location" [(ngModel)]="default_continent"
            class="wc-form-control position-relative no-outline inputheight wc-select">
                <option value="null" selected disabled>Select continent</option>
                <option [value]="continent" *ngFor="let continent of continentsList">{{continent | titlecase}} </option>

            </select>
    </div>
    <div class="row">
      <p *ngIf="continentErrorMessage" class="text-danger f-12">{{continentErrorMessage}}</p>
    </div>
    <div class="text-center justify-content-between align-items-center mt-3">
              <button data-testid="auto-app-default-location-modal-button-1" class="btn-trms-small" (click)="default_continent && saveChanges()">Save</button>

    </div>

  </div>
</div>
